import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../__legacy__/models/error.model';
import { IApiService } from '../../../__legacy__/services/api.service.base';
import { IApiServiceTraining } from '../../../__legacy__/services/api.service.training';
import { IJobModelsDto, IJobSettingsDto, IVerifyAnnotationToolsDto } from '../jobs.api.model';
import { IJobAnnotationTool, IValidJobType, JOB_TYPE, TRAINING_VARIANT } from '../jobs.model';

export interface IJobSettingsApiService {
  getJobSettingsAsync(workspaceId: string, variant: TRAINING_VARIANT, jobType: IValidJobType): Promise<IJobSettingsDto | ACDLError>;
  getVariantModelsAsync(workspaceId: string, variant: TRAINING_VARIANT): Promise<IJobModelsDto | ACDLError>;
  postVerifyAnnotationToolsAsync(
    workspaceId: string,
    variant: TRAINING_VARIANT,
    request: IVerifyAnnotationToolsDto[]
  ): Promise<IJobAnnotationTool[] | ACDLError>;
}

export namespace IJobSettingsApiService {
  export const $: interfaces.ServiceIdentifier<IJobSettingsApiService> = Symbol('JOB_SETTINGS_API_SERVICE');
}

@injectable()
export class JobSettingsApiService implements IJobSettingsApiService {
  constructor(@inject(IApiServiceTraining.$) private readonly apiTrainingService: IApiService) {}

  getJobSettingsAsync = async (workspaceId: string, variant: TRAINING_VARIANT, jobType: IValidJobType): Promise<IJobSettingsDto | ACDLError> => {
    return this.apiTrainingService.getAsync<IJobSettingsDto | ACDLError>(
      `/workspaces/${workspaceId}/model-variants/${variant}/schema/${jobType === JOB_TYPE.INFERENCE ? 'inference' : 'training'}`
    );
  };

  getVariantModelsAsync = async (workspaceId: string, variant: TRAINING_VARIANT): Promise<IJobModelsDto | ACDLError> => {
    return this.apiTrainingService.getAsync(`/workspaces/${workspaceId}/model-variants/${variant}/training-jobs`);
  };

  postVerifyAnnotationToolsAsync = async (
    workspaceId: string,
    variant: TRAINING_VARIANT,
    request: IVerifyAnnotationToolsDto[]
  ): Promise<IJobAnnotationTool[] | ACDLError> => {
    return this.apiTrainingService.postAsync(`/workspaces/${workspaceId}/model-variants/${variant}/annotation-tools`, request);
  };
}
